const RECOGNITION_LOCALES: Record<string, string> = {
  arabic: "ar-SA",
  bengali: "bn-BD",
  bulgarian: "bg-BG",
  cantonese: "zh-HK",
  catalan: "ca-ES",
  chinese: "zh-CN",
  croatian: "hr-HR",
  czech: "cs-CZ",
  danish: "da-DK",
  dutch: "nl-NL",
  english: "en-US",
  estonian: "et-EE",
  finnish: "fi-FI",
  french: "fr-FR",
  german: "de-DE",
  greek: "el-GR",
  hebrew: "he-IL",
  hindi: "hi-IN",
  hungarian: "hu-HU",
  indonesian: "id-ID",
  italian: "it-IT",
  japanese: "ja-JP",
  korean: "ko-KR",
  latvian: "lv-LV",
  lithuanian: "lt-LT",
  malay: "ms-MY",
  norwegian: "no-NO",
  polish: "pl-PL",
  portuguese: "pt-BR",
  romanian: "ro-RO",
  russian: "ru-RU",
  slovak: "sk-SK",
  slovenian: "sl-SI",
  spanish: "es-419",
  swedish: "sv-SE",
  tamil: "ta-IN",
  thai: "th-TH",
  turkish: "tr-TR",
  ukrainian: "uk-UA",
  urdu: "ur-PK",
  vietnamese: "vi-VN",
};

const RECOGNITION_ALIASES: Record<string, string> = {
  espanol: "es-419",
  "espanol latinoamerica": "es-419",
  "espanol latinoamericano": "es-419",
  "espanol mexico": "es-MX",
  "spanish latin america": "es-419",
  "spanish latinoamerica": "es-419",
  "spanish mexico": "es-MX",
  "spanish mexican": "es-MX",
};

const TWO_LETTER_LOCALES: Record<string, string> = {
  ar: "ar-SA",
  bg: "bg-BG",
  bn: "bn-BD",
  ca: "ca-ES",
  cs: "cs-CZ",
  da: "da-DK",
  de: "de-DE",
  el: "el-GR",
  en: "en-US",
  es: "es-419",
  et: "et-EE",
  fi: "fi-FI",
  fr: "fr-FR",
  he: "he-IL",
  hi: "hi-IN",
  hr: "hr-HR",
  hu: "hu-HU",
  id: "id-ID",
  it: "it-IT",
  ja: "ja-JP",
  ko: "ko-KR",
  lt: "lt-LT",
  lv: "lv-LV",
  ms: "ms-MY",
  nl: "nl-NL",
  no: "no-NO",
  pl: "pl-PL",
  pt: "pt-BR",
  ro: "ro-RO",
  ru: "ru-RU",
  sk: "sk-SK",
  sl: "sl-SI",
  sv: "sv-SE",
  ta: "ta-IN",
  th: "th-TH",
  tr: "tr-TR",
  uk: "uk-UA",
  ur: "ur-PK",
  vi: "vi-VN",
  yue: "zh-HK",
  zh: "zh-CN",
};

const BCP47_PATTERN = /^[a-z]{2,3}(?:-[a-z0-9]{2,8})+$/i;

const simplifyLanguageKey = (value: string): string =>
  value
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/_/g, "-")
    .replace(/[^a-z0-9-]+/g, " ")
    .trim();

export const resolveRecognitionLocale = (language?: string | null): string => {
  const raw = (language || "").trim();
  if (!raw) {
    return "en-US";
  }

  if (BCP47_PATTERN.test(raw)) {
    return raw;
  }

  const lowered = raw.toLowerCase();
  if (/^[a-z]{2}$/i.test(lowered)) {
    return TWO_LETTER_LOCALES[lowered] || "en-US";
  }

  const simplified = simplifyLanguageKey(raw);
  if (RECOGNITION_ALIASES[simplified]) {
    return RECOGNITION_ALIASES[simplified];
  }

  if (RECOGNITION_LOCALES[simplified]) {
    return RECOGNITION_LOCALES[simplified];
  }

  for (const [name, locale] of Object.entries(RECOGNITION_LOCALES)) {
    if (simplified.startsWith(`${name} `)) {
      return locale;
    }
  }

  return "en-US";
};
